
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-privacy",
      function () {
        return require("private-next-pages/data-privacy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-privacy"])
      });
    }
  